import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  static values = {
    eventId: Number
  }

  connect() {
    this.consumer = createConsumer()
    this.channel = this.consumer.subscriptions.create(
      { channel: "EventChannel", event_id: this.eventIdValue },
      {
        received: this.handleMessage.bind(this)
      }
    )
  }

  disconnect() {
    if (this.channel) {
      this.channel.unsubscribe()
    }
    if (this.consumer) {
      this.consumer.disconnect()
    }
  }

  handleMessage(data) {
    if (data.type === "rsvp_update") {
      this.showRsvpNotification(data)
    }
  }

  showRsvpNotification(data) {
    document.dispatchEvent(new CustomEvent("toast:show:html", {
      detail: {
        html: data.html,
        type: this.getToastType(data.rsvp_status),
        duration: 8000
      }
    }))
  }

  getToastType(rsvpStatus) {
    switch (rsvpStatus) {
      case "attending":
        return "success"
      case "not_attending":
        return "info"
      case "maybe":
        return "warning"
      default:
        return "info"
    }
  }
}
